import { ColumnDef } from "@tanstack/react-table";

export type ExternalRate = {
  id: string;
  currency: string;
  buyingRate: number | "loading" | null;
  sellingRate: number | "loading" | null;
  buyRateProvider: string;
  sellRateProvider: string;
};

export const externalRateColumns: ColumnDef<ExternalRate>[] = [
  {
    accessorKey: "currency",
    header: () => <div className="font-medium">CURRENCY PAIR</div>,
    cell: ({ row }) => (
      <div className="text-left">{row.getValue("currency")}</div>
    ),
  },
  {
    accessorKey: "buyingRate",
    header: () => <div className="text-right font-medium">OUR BUY RATE</div>,
    cell: ({ row }) => {
      const value = row.getValue("buyingRate") as number | "loading" | null;
      if (value === "loading" || value === null) {
        return (
          <div className="text-right">
            <span className="text-muted-foreground">loading</span>
          </div>
        );
      }
      return (
        <div className="text-right">
          {typeof value === "number" ? Number(value).toLocaleString() : String(value)}
        </div>
      );
    },
  },
  {
    accessorKey: "sellingRate",
    header: () => <div className="text-right font-medium">OUR SELL RATE</div>,
    cell: ({ row }) => {
      const value = row.getValue("sellingRate") as number | "loading" | null;
      if (value === "loading" || value === null) {
        return (
          <div className="text-right">
            <span className="text-muted-foreground">loading</span>
          </div>
        );
      }
      return (
        <div className="text-right">
          {typeof value === "number" ? Number(value).toLocaleString() : String(value)}
        </div>
      );
    },
  },
  {
    accessorKey: "buyRateProvider",
    header: () => <div className="font-medium">BUY RATE PROVIDER</div>,
    cell: ({ row }) => (
      <div className="text-left">{row.getValue("buyRateProvider")}</div>
    ),
  },
  {
    accessorKey: "sellRateProvider",
    header: () => <div className="font-medium">SELL RATE PROVIDER</div>,
    cell: ({ row }) => (
      <div className="text-left">{row.getValue("sellRateProvider")}</div>
    ),
  },
];
